import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ProgressBar } from 'react-bootstrap'
import Dropzone from 'react-dropzone'
import firebase from '../firebase'
import * as helpers from '../lib/HelperFunctions'
import '../components/css/IdeaProfileField.css'
import Logger from '../stores/Logger'
import ToolTip from '../components/ToolTip.js'

class IdeaProfileField extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ideaImageIsUploading: false,
            ideaImageProgress: 0,
            shouldShow: false,
            ideaImageTotalBytes: 0,
        }
    }
    onDropRejected(files) {
        console.error(files, 'rejected!')
        this.props.onImageRejected(files[0])
    }
    onDropAccepted(files) {
        if (files.length === 0)
            return

        var uploadTask = firebase.storage().ref('users/profileImages').child(helpers.guid()).put(files[0])
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                // console.log('Upload is ' + progress + '% done')
                this.setState({
                    ideaImageProgress: progress,
                    ideaImageTotalBytes: snapshot.totalBytes,
                })

                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused')
                        break
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        this.setState({
                            ideaImageIsUploading: true,
                        })
                        // console.log('Upload is running')
                        break

                    default:
                        break

                }
            }, (error) => {
                Logger.trackEvent('profileImageUploadFailed', 'error', error)
                console.error(error)
                this.onDropRejected(files)
                this.setState({
                    ideaImageIsUploading: false,
                })

            }, () => {
                // Upload completed successfully
                Logger.trackEvent('profileImageUploaded', 'size', this.state.ideaImageTotalBytes)
                this.setState({
                    ideaImageIsUploading: false,
                    ideaImageProgress: 100,
                    ideaImageTotalBytes: 0,
                })
                this.props.onNewImage(uploadTask.snapshot.downloadURL)
            })
    }

    buttonState() {
        this.props.buttonState = true
    }

    render() {
        return (
            <div style={{ position: 'relative'}}>
                {this.state.ideaImageIsUploading &&
                    <ProgressBar active now={this.state.ideaImageProgress} style={{ zIndex: 999, position: 'absolute', bottom: -20 + 'px', width: 100 + '%', marginLeft: 0 + 'px', marginRight: 0 + 'px' }} />
                }
                <Dropzone
                    accept='image/jpg, image/jpeg, image/png, image/gif'
                    onDropAccepted={this.onDropAccepted.bind(this)}
                    onDropRejected={this.onDropRejected.bind(this)}
                    disablePreview={true}
                    multiple={false}
                    //maxSize={10000000}
                    className='predo-profileField'
                    activeClassName='predo-profileField accepted'
                    rejectClassName='predo-profileField rejected'
                >
                    {this.props.imageUrl &&
                        <ToolTip style={{ display: 'inline-block' }} tipText={this.props.uploadText}>
                            {this.props.square ? (
                                <div>
                                    <img className='predo-teamLogoImage' src={this.props.imageUrl} alt='Profile' />
                                </div>
                            ) : (
                                    <div style={{ borderRadius: 50 + '%', textAlign: 'center', width: 90 + 'px', height: 90 + 'px', overflow: 'hidden' }}>
                                        {this.props.userName && (
                                            <img onError={(e)=>{helpers.onImageError(e, this.props.userName)}} className='predo-profileImage' size='90' src={this.props.imageUrl} alt='Profile' />
                                        )}
                                    </div>
                                )}
                        </ToolTip>
                    }
                </Dropzone>
            </div>
        )
    }
}
IdeaProfileField.propTypes = {
    imageUrl: PropTypes.string,
    imageHeight: PropTypes.number.isRequired,
    imageId: PropTypes.number,
    onNewImage: PropTypes.func.isRequired,
    onImageRejected: PropTypes.func.isRequired,
    allowButton: PropTypes.bool,
    uploadText: PropTypes.string,
    square: PropTypes.bool,
}

IdeaProfileField.defaultProps = {
    allowButton: false,
}

export default IdeaProfileField



// WEBPACK FOOTER //
// ./src/components/IdeaProfileField.js